var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTruck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "#FFF",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.78 6.82 13.8 4.84a.74.74 0 0 0-.52-.22h-1.9V2.06c0-.41-.33-.74-.74-.74H.74c-.41 0-.74.33-.74.74v8.58c0 .41.33.74.74.74h.76a2.39 2.39 0 1 0 4.42 0h4.16a2.39 2.39 0 1 0 4.42 0h.76c.41 0 .74-.33.74-.74v-3.3c0-.2-.08-.39-.22-.52M1.48 2.8h8.41v7.09H1.48zm3.14 9.49c0 .5-.41.91-.91.91s-.91-.41-.91-.91.41-.91.91-.91.91.41.91.91m7.67.91c-.5 0-.91-.41-.91-.91s.41-.91.91-.91.91.41.91.91-.41.91-.91.91m2.23-3.3h-3.13V6.11h1.59l1.54 1.54z"
})));
export default SvgTruck;